export const white = '#fff'
